import { Divider } from 'antd';
import { Optional } from '../Shared';
import { ShiftStatusTag } from './lib/shift-status';

type ShiftForegroundProps = {
  readonly userInfo: string;
  readonly shiftDuration: string;
  readonly shiftTime: string;
  readonly isVacant: boolean;
  readonly shiftStatus: string;
  readonly showShiftStatus: boolean;
};

/**
 * The foreground of a shift button element, containing the shift time, duration and personnel initial.
 */
const ShiftForeground = ({
  userInfo,
  shiftDuration,
  shiftTime,
  isVacant,
  shiftStatus,
  showShiftStatus,
}: ShiftForegroundProps) => (
  <div
    style={{
      display: 'block',
      position: 'relative',
      width: '100%',
      overflow: 'auto',
      padding: '2px',
      color: isVacant ? '#000000' : '#ffffff',
    }}
  >
    <div className="shift-btn-text">{userInfo}</div>
    <Optional show={showShiftStatus}>
      <div className="shift-btn-text" style={{ width: '100%' }}>
        <ShiftStatusTag status={shiftStatus} />
      </div>
    </Optional>
    <Divider style={{ margin: '2px 0', borderTop: '1px dashed #ffffff' }} />
    <div className="shift-btn-text">{shiftTime}</div>
    <div className="shift-btn-text">{shiftDuration}</div>
  </div>
);

export default ShiftForeground;
